import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import R, {clone, isEmpty} from 'ramda'
import moment from 'moment'
import ReservationBmxActions, { ReservationBmxRedux, ReservationBmxTypes } from '../Redux/ReservationBmxRedux'
import { notificationSuccess, notificationFail } from '../Redux/NotificationActions'
import { parseFullName } from '../../utils/Utils'


const ReservationBmxCRUDObservable = createCRUDObservable({
  mainRedux: ReservationBmxRedux,
  reduxPath: 'reservationBmx',
  dataHandlers: {
    get: response => response.data,
  },
})

// const createMedicineEpic = (action$, store, { Api }) => (
//   action$.ofType(MedicineTypes.createReservationRequest)
//     .mergeMap(({ reservationInfo }) => (
//       Api.parent_platform_medicine.create(medicineInfo)
//         .then(response => response)
//         .catch(err => err)
//     ))
//     .flatMap((response) => {
//       const { status } = response
//       if (!(status >= 200 && status < 300)) {
//         return [
//           ReservationActions.createReservationrror(response.error),
//           notificationFail('Accion Fallida'),
//         ]
//       }
//       return [
//         ReservationActions.createMedicineSuccess(response.data.data),
//         MedicinesActions.updateMedicines(response.data.data),
//         notificationSuccess('Accion Exitosa'),
//       ]
//     })
// )

const getReservationeBmxEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.getReservationBmxRequest)
    .mergeMap(({centerId, query }) =>
      Observable.fromPromise(
        Api.reservationBmx.getReservationBmx(centerId, query)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.getReservationBmxError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response
          return [
            ReservationBmxActions.getReservationBmxSuccess(data),
            // notificationSuccess('Reservación guardada exitosamente.'),
          ]
        }
      ),
)
const getReservationeB2bEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.getReservationB2bRequest)
    .mergeMap(({centerId, query }) =>
      Observable.fromPromise(
        Api.reservationBmx.getReservationB2b(centerId, query)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            let resp = [
              ReservationBmxActions.getReservationB2bError(response.error),
              // notificationFail('Ocurrio un Error', response.error),
            ]
            if (!(status >= 400 &&  status <500)){
              resp.push(notificationFail('Ocurrio un Error', response.error),)
            }
            return resp
          }
          const { data } = response
          return [
            ReservationBmxActions.getReservationB2bSuccess(data),
            // notificationSuccess('Reservación guardada exitosamente.'),
          ]
        }
      ),
)

const postReservationB2bEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.postReservationB2bRequest)
    .mergeMap(({centerId , data }) =>
      Observable.fromPromise(
        Api.reservationBmx.postReservationB2b(centerId,data)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.postReservationB2bError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          const reservations = clone(store.getState().reservationBmx.getb2b.results.data)
        if(!isEmpty(reservations)){
          const index =  R.findIndex(R.propEq('id', data.id))(reservations)

          if (index > -1){
            reservations[index] = data
          } else {
            reservations.push(data)
          }
        }
          return [
            ReservationBmxActions.postReservationB2bSuccess(reservations),
            notificationSuccess('Reservación guardada exitosamente.'),
          ]
        }
      ),
)
const authorizeReservationBmxEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.authorizeReservationBmxRequest)
    .mergeMap(({ reservationId }) =>
      Observable.fromPromise(
        Api.reservationBmx.authorizeReservation(reservationId)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.authorizeReservationBmxError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          const state = store.getState().reservationBmx
          const users = R.clone(store.getState().auth.user)
          const reservations = clone(state.get.results.data)
          const index =  R.findIndex(R.propEq('id', reservationId))(reservations)
          if (index > -1){
            reservations[index].authorized_at = moment().format('YYYY-MM-DD')
            reservations[index].authorized_by = {
              id:users.id,
              user:parseFullName(users)
            }
            reservations[index].status = data.status
          }
          return [
            ReservationBmxActions.authorizeReservationBmxSuccess(reservations),
            notificationSuccess('Reservación autorizada exitosamente.'),
          ]
        }
      ),
)
const cancelReservationBmxEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.cancelReservationBmxRequest)
    .mergeMap(({ reservationId }) =>
      Observable.fromPromise(
        Api.reservationBmx.cancelReservation(reservationId)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.cancelReservationBmxError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          const state = store.getState().reservationBmx
          const users = R.clone(store.getState().auth.user)
          const reservations = clone(state.get.results.data)
          const index =  R.findIndex(R.propEq('id', reservationId))(reservations)

          if (index > -1){
            reservations[index] = data
          }
          return [
            ReservationBmxActions.cancelReservationBmxSuccess(reservations),
            notificationSuccess('Reservación actualizada exitosamente.'),
          ]
        }
      ),
)

const paiedReservationBmxEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.paiedReservationBmxRequest)
    .mergeMap(({ reservationId ,paymentId}) =>
      Observable.fromPromise(
        Api.reservationBmx.paiedReservation(reservationId,paymentId)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.paiedReservationBmxError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          const state = store.getState().reservationBmx
          const users = R.clone(store.getState().auth.user)
          const reservations = clone(state.get.results.data)
          const index =  R.findIndex(R.propEq('id', reservationId))(reservations)

          if (index > -1){
            reservations[index] = data
          }
          return [
            ReservationBmxActions.paiedReservationBmxSuccess(reservations),
            notificationSuccess('Reservación actualizada exitosamente.'),
          ]
        }
      ),
)

const pendingReservationBmxEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.pendingReservationBmxRequest)
    .mergeMap(({ reservationId }) =>
      Observable.fromPromise(
        Api.reservationBmx.pendingReservation(reservationId)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.pendingReservationBmxError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data
          const state = store.getState().reservationBmx
          const users = R.clone(store.getState().auth.user)
          const reservations = clone(state.get.results.data)
          const index =  R.findIndex(R.propEq('id', reservationId))(reservations)

          if (index > -1){
            reservations[index] = data
          }
          return [
            ReservationBmxActions.pendingReservationBmxSuccess(reservations),
            notificationSuccess('Reservación actualizada exitosamente.'),
          ]
        }
      ),
)
const getStudentPaymentsEpic = (action$, store, { Api }) =>
  action$.ofType(ReservationBmxTypes.getStudentPaymentsRequest)
    .mergeMap(({ studentId }) =>
      Observable.fromPromise(
        Api.reservationBmx.getSutdentPayments(studentId)
          .then(response => response)
          .catch(error => error)
        ).flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [
              ReservationBmxActions.getStudentPaymentsError(response.error),
              notificationFail('Ocurrio un Error', response.error),
            ]
          }
          const { data } = response.data

          return [
            ReservationBmxActions.getStudentPaymentsSuccess(data),
            // notificationSuccess('Reservación actualizada exitosamente.'),
          ]
        }
      ),
)

export const reservationBmxObservers = Object.assign({}, ReservationBmxCRUDObservable.observers, {})
export const reservationBmxEpic = combineEpics(
  ReservationBmxCRUDObservable.epic,
  getReservationeBmxEpic,
  authorizeReservationBmxEpic,
  pendingReservationBmxEpic,
  cancelReservationBmxEpic,
  paiedReservationBmxEpic,
  getStudentPaymentsEpic,
  getReservationeB2bEpic,
  postReservationB2bEpic
)



// WEBPACK FOOTER //
// ./src/Data/Observables/ReservationBmxObserver.js